window.addEventListener('load', () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.sk-accordion__btn');
    if (!btn) return;

    btn.closest('.sk-accordion__item').classList.toggle('open');
  });

  document.querySelectorAll('.sk-accordion').forEach(wrapper => {
    const searchInput = wrapper.querySelector('.sk-accordion__search');
    const items = Array.from(wrapper.querySelectorAll('.sk-accordion__item'));

    if (!searchInput) return;

    let debounceTimer = null;

    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        const query = searchInput.value.trim().toLowerCase();
        const doHighlight = query.length > 1;
        let hasResults = false;

        items.forEach(item => {
          const btn = item.querySelector('.sk-accordion__btn');
          const text = item.querySelector('.sk-accordion__text');

          removeHighlights(btn);
          removeHighlights(text);

          if (!query || item.textContent.toLowerCase().includes(query)) {
            item.style.display = '';
            hasResults = true;

            if (doHighlight) {
              highlightText(btn, query);
              highlightText(text, query);
            }
          } else {
            item.style.display = 'none';
          }
        });

        const noResults = wrapper.querySelector('.no-results');
        noResults.style.display = hasResults ? 'none' : 'block';
      }, 150);
    });
  });
});

function removeHighlights(root) {
  if (!root) return;

  root.querySelectorAll('mark').forEach(mark => {
    mark.replaceWith(document.createTextNode(mark.textContent));
  });

  root.normalize();
}

function highlightText(root, query) {
  if (!root || !query) return;

  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        if (!node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (node.parentNode.tagName === 'MARK') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    }
  );

  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);

  nodes.forEach(node => {
    const value = node.nodeValue;
    const regex = new RegExp(query, 'gi');

    if (!regex.test(value)) return;

    const frag = document.createDocumentFragment();
    let lastIndex = 0;

    value.replace(regex, (match, index) => {
      frag.appendChild(
        document.createTextNode(value.slice(lastIndex, index))
      );

      const mark = document.createElement('mark');
      mark.textContent = match;
      frag.appendChild(mark);

      lastIndex = index + match.length;
    });

    frag.appendChild(document.createTextNode(value.slice(lastIndex)));

    node.replaceWith(frag);
  });
}
